<app-sales-person-attendance-dashboard-subheader
  [userId]="this.userId()"
  [displayedUser]="this.displayedUser()"
  (queryChange)="this.onQueryChange($event)"
  (salesPersonChange)="this.onSalesPersonChange($event)"
/>

<div>
  <div class="details-content container-fluid h-100">
    <div class="row h-100">
      <div class="col-content d-flex flex-column h-100">
        <div class="page-container container-fluid">
          <div class="card card-light w-100">
            <div class="card-body">
              <div class="container-fluid">
                <div class="row mb-3">
                  <div class="col-3">
                    <app-kpi
                      [title]="'ATTENDANCE_LBL_DAYS_WITH_PRESENCE' | translate"
                      [kpiData]="this.presenceCount()"
                    />
                  </div>
                  <div class="col-3">
                    <app-kpi
                      [title]="'ATTENDANCE_LBL_MEDIAN_ARRIVAL' | translate"
                      [kpiData]="this.medianStart()"
                    />
                  </div>
                  <div class="col-3">
                    <app-kpi
                      [title]="'ATTENDANCE_LBL_MEDIAN_DEPARTURE' | translate"
                      [kpiData]="this.medianEnd()"
                    />
                  </div>
                  <div class="col-3">
                    <app-kpi
                      [title]="'ATTENDANCE_LBL_MEDIAN_AMPLITUDE' | translate"
                      [kpiData]="this.medianAmplitude()"
                    />
                  </div>
                </div>

                <div class="attendance-chart" [style.height.px]="this.chartHeightPx()">
                  <canvas #chartCanvas></canvas>
                </div>

                <app-attendance-chart-legend />

                @if (!this.userId() && this.hasNoUsers()) {
                  <div class="text-muted text-center py-4">
                    {{ 'ATTENDANCE_LBL_NO_DATA' | translate }}
                  </div>
                } @else if (!this.userId()) {
                  <div class="text-muted text-center py-4">
                    {{ 'ATTENDANCE_LBL_PICK_SALESPERSON' | translate }}
                  </div>
                } @else if (this.hasNoPresence()) {
                  <div class="text-muted text-center py-4">
                    {{ 'ATTENDANCE_LBL_NO_PRESENCE' | translate }}
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
